const withVariables = /\{[^/]+\}/

export const isDynamicRoute = ({ route }: { route: string }) =>
  withVariables.test(route)
